import React from "react";

import CloseIcon from '../../icons/CloseIcon';

const ModalCloseIcon = ({
  toggleModal
}) => {
  return (
    <a type="button" onClick={toggleModal}>
      <CloseIcon className="fill-dark" />
    </a>
  )
}

export default ModalCloseIcon;